var _g, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStoreIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2553_58)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    rx: 8,
    fill: "#41D5FB",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8242 19.8339V32.4902C31.8242 32.6669 31.754 32.8363 31.6291 32.9613C31.5041 33.0862 31.3347 33.1564 31.158 33.1564H19.1679V23.1645C19.1679 22.9879 19.0977 22.8184 18.9728 22.6935C18.8478 22.5686 18.6784 22.4984 18.5017 22.4984H13.1728C12.9961 22.4984 12.8267 22.5686 12.7018 22.6935C12.5768 22.8184 12.5067 22.9879 12.5067 23.1645V33.1564H9.84217C9.6655 33.1564 9.49607 33.0862 9.37115 32.9613C9.24623 32.8363 9.17605 32.6669 9.17605 32.4902V19.8339H9.40253C10.3751 19.8339 11.2677 19.3577 11.8206 18.6016C11.8339 18.6149 11.8439 18.6349 11.8539 18.6516C12.1331 19.0202 12.4941 19.3189 12.9086 19.5241C13.323 19.7293 13.7795 19.8354 14.2419 19.8339H15.0812C16.0904 19.8339 16.9863 19.3343 17.5325 18.5616C17.5758 18.6149 17.6191 18.6715 17.6658 18.7248C17.978 19.0739 18.3604 19.3532 18.788 19.5443C19.2156 19.7354 19.6787 19.8341 20.1471 19.8339H20.8532C21.3215 19.8341 21.7846 19.7354 22.2122 19.5443C22.6398 19.3532 23.0222 19.0739 23.3345 18.7248C23.3811 18.6715 23.4244 18.6149 23.4677 18.5616C23.7442 18.9548 24.1113 19.2757 24.538 19.4971C24.9646 19.7186 25.4383 19.8341 25.919 19.8339H26.7583C27.7042 19.8339 28.5735 19.401 29.1464 18.6516C29.1564 18.6349 29.1663 18.6149 29.1797 18.6016C29.4577 18.9824 29.8214 19.2924 30.2415 19.5065C30.6616 19.7206 31.1262 19.8328 31.5977 19.8339H31.8242ZM28.4936 28.4935V23.1645C28.4936 22.9879 28.4234 22.8184 28.2985 22.6935C28.1735 22.5686 28.0041 22.4984 27.8274 22.4984H23.1646C22.9879 22.4984 22.8185 22.5686 22.6936 22.6935C22.5687 22.8184 22.4985 22.9879 22.4985 23.1645V28.4935C22.4985 28.6702 22.5687 28.8396 22.6936 28.9645C22.8185 29.0895 22.9879 29.1596 23.1646 29.1596H27.8274C28.0041 29.1596 28.1735 29.0895 28.2985 28.9645C28.4234 28.8396 28.4936 28.6702 28.4936 28.4935ZM11.8069 7.84375C11.5492 7.84375 11.2971 7.91848 11.081 8.05888C10.865 8.19928 10.6942 8.39932 10.5896 8.63477L7.2443 16.1603C7.00316 16.7048 7.06145 17.3027 7.40417 17.7916C7.72657 18.2512 8.27312 18.5017 8.83433 18.5017H9.40253C10.1486 18.5017 10.808 17.9988 11.0079 17.2827L12.55 11.7239L13.6291 7.84375H11.8069ZM15.0113 7.84375L12.6365 16.3901C12.4967 16.8963 12.5999 17.4259 12.9163 17.8456C13.2327 18.2619 13.7157 18.5017 14.2419 18.5017H15.0812C15.9338 18.5017 16.6433 17.8655 16.7365 17.0196L17.759 7.84375H15.0113ZM21.9023 7.84375H19.0979L18.1587 16.2835C18.0987 16.8464 18.2786 17.4126 18.6583 17.8356C19.0413 18.2652 19.5709 18.5017 20.1471 18.5017H20.8532C21.4293 18.5017 21.9589 18.2652 22.3419 17.8356C22.5292 17.6262 22.6704 17.3799 22.7564 17.1125C22.8425 16.8452 22.8715 16.5628 22.8415 16.2835L21.9023 7.84375ZM25.989 7.84375H23.2412L24.2637 17.0196C24.3078 17.4275 24.5013 17.8046 24.807 18.0782C25.1126 18.3519 25.5087 18.5028 25.919 18.5017H26.7583C27.2846 18.5017 27.7675 18.2619 28.0839 17.8456C28.4003 17.4259 28.5036 16.8963 28.3637 16.3901L25.989 7.84375ZM30.4107 8.63477C30.306 8.39932 30.1353 8.19928 29.9192 8.05888C29.7031 7.91848 29.451 7.84375 29.1933 7.84375H27.3711L28.4503 11.7239L29.9923 17.2827C30.1922 17.9988 30.8516 18.5017 31.5977 18.5017H32.1659C32.7274 18.5017 33.274 18.2512 33.5961 17.7916C33.9391 17.3027 33.9971 16.7045 33.7559 16.1603L30.4107 8.63477Z",
    fill: "#2C6CA0"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2553_58)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 23,
    width: 18,
    height: 18,
    rx: 9,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.5,
    y: 23.5,
    width: 17,
    height: 17,
    rx: 8.5,
    stroke: "#D3F5FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.408 32.7347H32.7345V36.4082C32.7345 36.6031 32.6571 36.7899 32.5193 36.9277C32.3815 37.0655 32.1946 37.1429 31.9998 37.1429C31.8049 37.1429 31.6181 37.0655 31.4803 36.9277C31.3425 36.7899 31.2651 36.6031 31.2651 36.4082V32.7347H27.5916C27.3968 32.7347 27.2099 32.6573 27.0721 32.5195C26.9343 32.3818 26.8569 32.1949 26.8569 32C26.8569 31.8052 26.9343 31.6183 27.0721 31.4805C27.2099 31.3427 27.3968 31.2653 27.5916 31.2653H31.2651V27.5919C31.2651 27.397 31.3425 27.2101 31.4803 27.0724C31.6181 26.9346 31.8049 26.8572 31.9998 26.8572C32.1946 26.8572 32.3815 26.9346 32.5193 27.0724C32.6571 27.2101 32.7345 27.397 32.7345 27.5919V31.2653H36.408C36.6028 31.2653 36.7897 31.3427 36.9275 31.4805C37.0652 31.6183 37.1426 31.8052 37.1426 32C37.1426 32.1949 37.0652 32.3818 36.9275 32.5195C36.7897 32.6573 36.6028 32.7347 36.408 32.7347Z",
    fill: "#2C6CA0"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 44,
    height: 44,
    rx: 7.5,
    stroke: "#41D5FB",
    strokeOpacity: 0.16
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2553_58",
    x: 13,
    y: 16,
    width: 38,
    height: 38,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.133333 0 0 0 0 0.168627 0 0 0 0 0.270588 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2553_58"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2553_58",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2553_58"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    rx: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoreIcon);
export default __webpack_public_path__ + "static/media/store_icon.b0f1c91213d2e9d29135d21fc48ec715.svg";
export { ForwardRef as ReactComponent };